import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiConnector, Table } from '@cureskin/api-client';

@Component({
    selector: 'ticket-history',
    templateUrl: './ticket-history.html',
    standalone: false
})
export class TicketHistoryComponent {
  ticket: Table.SupportTicket;
  ticketHistory: Array<Table.SupportTicketLog>;
  constructor(private dialogRef: MatDialogRef<TicketHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) { }

  async ngOnInit(): Promise<void> {
    this.ticket = this.data.ticket;
    this.ticketHistory = await ApiConnector.find(Table.SupportTicketLog, {
      where: { supportTicket: this.ticket },
      include: ['completedBy', 'createdBy'],
      descending: 'createdAt',
    });
  }

  hideModal(): void {
    this.dialogRef.close();
  }
}
